import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import PatientSlotAdditionalInfo from './PatientSlotAdditionalInfo';
import PatientSlotInfo from './PatientSlotInfo';
import DischargeAction from '../../entities/patient/views/DischargeActionLiason';
import MedsDeliveredAction from '../../entities/patient/views/MedsDeliveredAction';

const PatientInfoWrapper = styled.div`
  flex: 1;
  overflow: hidden;

  ${props =>
    props.miniView &&
    css`
      min-height: 3.8em;
    `}
`;

const DischargeActionContainer = styled.div`
  display: flex;
  white-space: nowrap;
  flex: 0 1 0;
  justify-content: flex-end;
  min-width: auto;
  gap: 0.5em;
`;

const PatientInfo = ({
  status,
  physician,
  procedure,
  patient,
  patientId,
  patientType,
  patientData,
  bed,
  showBedNumber = false,
  timeEntered,
  compactView,
  readyForOr,
  readyForSurgeon,
  readyInOr,
  roomName,
  familyReady,
  readyForPickup,
  isHoldProcedure,
  isBlockNerve,
  expectedExitTime,
  size,
  allowWrap,
  miniView,
  preOpFocused,
  pacuFocused,
  showPreOpNote,
  preOpNote,
  showPacuNote,
  pacuNote,
  showPatientNote,
  patientNote,
  isDPU,
  showRoom,
  showDuration,
  blockNerveFollow,
  called,
  transferredToChair,
  transferredToPT,
  ptComplete,
  isPreOp,
  isSuperAdmin,
  noAdditionalInfo,
  messagingView,
  grow,
  readyForAnesthesia,
  isSpinalTimeout,
  showProcedureType = true,
  room,
  showLatePreOpIndicator,
  showPacuLateIndicator,
  isGroupAdmin,
}) => (
  <PatientInfoWrapper miniView={miniView}>
    <PatientSlotInfo
      bed={bed}
      showBedNumber={showBedNumber}
      physician={physician}
      patient={patient}
      patientId={patientId}
      patientType={patientType}
      procedure={procedure}
      size={size}
      readyForSurgeon={readyForSurgeon}
      readyForOr={readyForOr}
      readyInOr={readyInOr}
      familyReady={familyReady}
      readyForPickup={readyForPickup}
      allowWrap={allowWrap}
      miniView={miniView}
      isHoldProcedure={isHoldProcedure}
      isBlockNerve={isBlockNerve}
      called={called}
      transferredToChair={transferredToChair}
      transferredToPT={transferredToPT}
      ptComplete={ptComplete}
      isDPU={isDPU}
      isPreOp={isPreOp}
      isSuperAdmin={isSuperAdmin}
      messagingView={messagingView}
      patientData={patientData}
      grow={grow}
      readyForAnesthesia={readyForAnesthesia}
      isSpinalTimeout={isSpinalTimeout}
      timeEntered={timeEntered}
      room={room}
      showLatePreOpIndicator={showLatePreOpIndicator}
      showPacuLateIndicator={showPacuLateIndicator}
      isGroupAdmin={isGroupAdmin}
      medsDeliveryStatus={patientData?.medsDeliveryStatus}
    />
    {!noAdditionalInfo && !messagingView && (
      <PatientSlotAdditionalInfo
        bed={bed}
        procedure={procedure}
        timeEntered={timeEntered}
        compactView={compactView}
        status={status}
        size={size}
        miniView={miniView}
        roomName={roomName}
        expectedExitTime={expectedExitTime}
        preOpFocused={preOpFocused}
        pacuFocused={pacuFocused}
        showPreOpNote={showPreOpNote}
        showPacuNote={showPacuNote}
        showPatientNote={showPatientNote}
        preOpNote={preOpNote}
        pacuNote={pacuNote}
        patientNote={patientNote}
        showRoom={showRoom}
        showDuration={showDuration}
        blockNerveFollow={blockNerveFollow}
        showProcedureType={showProcedureType}
      />
    )}
    {messagingView && !!patient && (
      <DischargeActionContainer>
        <MedsDeliveredAction id={patientData?.id} patient={patientData} />
        <DischargeAction id={patientData?.id} patient={patientData} />
      </DischargeActionContainer>
    )}
  </PatientInfoWrapper>
);

PatientInfo.propTypes = {
  status: PropTypes.oneOf(['alert', 'occupied', 'empty', 'ready', 'cleaning']),
  physician: PropTypes.string,
  procedure: PropTypes.string,
  patient: PropTypes.any,
  timeEntered: PropTypes.instanceOf(Date),
  compactView: PropTypes.bool,
  ready: PropTypes.bool,
  bed: PropTypes.string,
};

export default PatientInfo;
